import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 4px;
`

export const HeaderLabel = styled.label`
  color: var(--foreground-neutral, #14171f);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  @media (max-width: ${({ theme }) => theme.responsive.tablet.valueString}) {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`

export const UploadButtonContainer = styled.label`
  position: relative;

  min-width: 150px;
`

export const UploadButtonLabel = styled.div<{ disabled?: boolean }>`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 6px;
  border: 1px solid var(--border-neutral, #bbc1d3);

  color: var(--foreground-neutral, #4d5874);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  position: relative;

  background: ${({ disabled }) => (disabled ? '#F4F5F7' : 'white')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

export const UploadButtonInput = styled.input`
  position: absolute;

  width: 100%;
  height: 100%;

  opacity: 0;
  z-index: -1;
`

export const UploadImg = styled.img``

export const DropAreaContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 80px;
  padding: 32px;
  box-sizing: border-box;
  border-radius: 6px;
  margin: 6px 0;
  position: relative;
  background: ${({ disabled }) => (disabled ? '#F4F5F7' : 'white')};
  border: 1px solid ${({ disabled }) => (disabled ? '#DFE2EA' : '#bbc1d3')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

export const DropAreaInput = styled.input`
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
`

export const CameraImg = styled.img``

export const FilesGridContainer = styled.div<{ disabled?: boolean }>`
  display: ${({ disabled }) => (disabled ? 'grid' : 'flex')};
  ${({ disabled }) =>
    disabled &&
    `
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
    margin-top: 6px;
  `}
  ${({ disabled }) =>
    !disabled &&
    `
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
  `}
`

export const FileGridItem = styled.div<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled
      ? `
    position: relative;
    aspect-ratio: 1;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid var(--border-neutral-faded, #dfe2ea);
  `
      : `
    min-height: 80px;
    padding: 8px 16px 8px 8px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid var(--border-neutral-faded, #dfe2ea);
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  `}
`

export const FilePreview = styled.img<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled
      ? `
    width: 100%;
    height: 100%;
    object-fit: contain;
    cursor: pointer;
  `
      : `
    width: 62px;
    height: 62px;
    border-radius: 2px;
    object-fit: contain;
  `}
`

export const FileOverlay = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
`

export const HintLabel = styled.label`
  color: var(--foreground-neutral-faded, #4d5874);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const FileRow = styled.div`
  min-height: 80px;
  padding: 8px 16px 8px 8px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid var(--border-neutral-faded, #dfe2ea);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const FilesAreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
`

export const FileName = styled.label`
  color: var(--foreground-neutral, #14171f);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-left: 12px;
  box-sizing: border-box;
  min-width: 0;
  flex: 1;
  cursor: pointer;
`

export const ButtonFileRow = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 28px;
  height: 28px;

  cursor: pointer;
`

export const ImgFileRow = styled.img``
